import { Link } from 'components'
import React from 'react'

import { ThunderIcon } from '../../assets/Icon'
import { PriceCard } from '../../components/PriceCard'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { useGenerateApplyNowLink } from '../../components/useGenerateApplyNowLink'
import { bootcampsData, BootcampsType } from '../../data/bootcampsData'
import { PricingSectionData } from '../../data/pricingSection'

const PricingSection = (props: { type?: BootcampsType }) => {
  const { type = 'fullstack' } = props
  const to = useGenerateApplyNowLink(type)

  return (
    <div className="bg-gradient-to-r from-[#3C3C78] from-100% to-[#3C3C7800] to-0%">
      <SectionLayout className="max-w-7xl mx-auto">
        <SectionHeader className="text-left">
          <span className="text-primary">Invest</span> in Your Future
        </SectionHeader>
        <SectionContent className="gap-10 text-gray-50">
          <div className="flex flex-col sm:flex-row gap-16 justify-between">
            <div className="text-xl flex flex-col gap-9 sm:w-1/2">
              <p>
                {PricingSectionData[type].heading}
                <span className="text-2xl text-primary font-bold">
                  {PricingSectionData[type].highlightedHeading}
                </span>
              </p>
              <ul className="font-semibold flex flex-col gap-6">
                {PricingSectionData[type].specification.map((points, idx) => (
                  <li key={idx} className="flex flex-row gap-3">
                    <ThunderIcon /> <p>{points}</p>
                  </li>
                ))}
              </ul>
            </div>
            <PriceCard
              to={to}
              actual_price={bootcampsData[type].price}
              early_offer={
                bootcampsData[type].price -
                (bootcampsData[type].price * 20) / 100
              }
            />
          </div>
          <div>
            <p className="text-xl">
              Having doubts?{' '}
              <Link
                href={''}
                className="font-bold text-primary hover:text-primary-dark hover:underline">
                ping us
              </Link>
            </p>
          </div>
        </SectionContent>
      </SectionLayout>
    </div>
  )
}

export default PricingSection
